<div class="row row-cols-12">
    <!-- SPACING so the button aligns nicely with the Logo/Viewer documents-->
    <div
        class="col-0 col-sm-0 col-md-1 col-lg-1 col-xl-1 offset-0 offset-sm-0 offset-md-0 offset-lg-1 offset-xl-2 text-center">
    </div>
    <!-- Start of the header-->
    <div class="col-12 col-sm-12 col-md-10 col-lg-9 col-xl-6">

        <!-- Start button-->
        <ng-container *ngIf="!startButtonClicked">
            <button [ngClass]="{'button-wiggle': isWiggleAllowed}"
                class="btn btn-sm btn-success  me-2 ms-2 ms-md-0 order-1 order-sm-1 order-md-1 order-lg-1 order-xl-1"
                type="button" id="startButton" (click)="startActions()" translate="Button.Start"></button>
        </ng-container>
        <!-- Continue button-->
        <ng-container *ngIf="startButtonClicked">
            <button [ngClass]="{'button-wiggle': isWiggleAllowed}"
            class="btn btn-sm btn-success me-2 ms-2 ms-md-0 order-1 order-sm-1 order-md-1 order-lg-1 order-xl-1"
                type="button" (click)="startActions()" translate="Button.Continue"></button>
        </ng-container>
        <!-- Action menu thingie -->
        <span class="float-end d-flex d-block">
            <button type="button" class="btn btn-sm btn-secondary me-2 me-md-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-list"></i>
            </button>
            <!-- Dropdown opties for acton menu-->
            <div class="dropdown">
                <ul class="dropdown-menu dropdown-menu-end">
                    <!-- always display the action overview option-->
                    <li>
                        <a class="dropdown-item" (click)="openActionSummaryModal()"
                            translate="Button.ActionOverview"></a>
                    </li>
                    <!-- aDownload request as a preview -->
                    <li *ngIf="showPreviewDownloadOption">
                        <a class="dropdown-item" (click)="downloadReviewCopy()" translate="Button.DownloadCopy"></a>
                    </li>
                    <!-- Reject the request -->
                    <li *ngIf="showRejectOption">
                        <a class="dropdown-item" (click)="openRejectModal()" translate="Button.RejectRequest"></a>
                    </li>
                    <!-- always display log out option -->
                    <li>
                        <a class="dropdown-item" (click)="logOut()" translate="Button.Logout"></a>
                    </li>
                </ul>
            </div>
        </span>
    </div>
</div>